import { render, staticRenderFns } from "./class-list.vue?vue&type=template&id=125c1948&scoped=true"
import script from "./class-list.vue?vue&type=script&lang=ts"
export * from "./class-list.vue?vue&type=script&lang=ts"
import style0 from "./class-list.vue?vue&type=style&index=0&id=125c1948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c1948",
  null
  
)

export default component.exports